import { derived, readable } from "svelte/store";
import { storage } from "./localstorage.js";

export const entities = storage("entities", []);

export const entityData = storage("entity-data", {});

export const meta = storage("meta", { inputOpen: true });

const curtime = readable(new Date(), function start(set) {
  const interval = setInterval(() => {
    set(new Date().getTime());
  }, 1000);

  return function stop() {
    clearInterval(interval);
  };
});

export const time = derived([curtime, meta], ([t, { stopwatch }]) => {
  let res;
  if (!stopwatch) {
    t = 0;
  } else if (stopwatch.state === "RUN") {
    res = t - stopwatch.start;
  } else {
    res = stopwatch.end - stopwatch.start;
  }
  return res ?? 0;
});
